export default function isGuessOrDraftGuessEmpty(guessOrDraftGuess: any) {
  const content = guessOrDraftGuess.get('content');

  // All draft guesses except graphing, free-entry, and free-response.
  if (content.isEmpty()) {
    return true;
  }

  // Graphing draft guesses
  if (content.has('entities') && content.get('entities').size === 0) {
    return true;
  }

  // Free-response draft guesses
  if (content.has('text') && content.has('raw') && !hasFreeResponseDraftGuess(content)) {
    return true;
  }

  // Free-entry draft guesses
  if (content.every((freeEntryValue) => freeEntryValue === '')) {
    return true;
  }

  return false;
}

function hasFreeResponseDraftGuess(content) {
  const hasTextSubmission = content.get('text')?.trim() !== '';

  const rawContent = JSON.parse(content.get('raw') || '[]');

  const hasNonTextSubmission = rawContent.some((node) => {
    return ['audio-chip', 'image'].includes(node.type);
  });

  return hasTextSubmission || hasNonTextSubmission;
}
